
import { makeAutoObservable, runInAction } from 'mobx';
import { getUserListToManageAsync } from '../../api/getUserListToManage';
import { getUserLookupContactsByResident } from '../../api/getUserLookupContactsByResident';

class UserListToManage {
    error: string = "";
    isLoading: boolean = false;
    activeRequestId: number = 0;
    data?: {
        users?: Array<any>;
        pageNum?: number;
        totalPage?: number;
        from?: number;
        to?: number;
        total?: number;
        search?: string;
    }
    isOpenModalReassignEmail: boolean = false;
    reassignEmail: string = "";
    isReassignEmailError: boolean = false;
    newReassignEmails: Array<{ value: string; label: string }> = [];
    selectedNewResidentKey: string = "";
    selectedNewContactKey: string = "";
    isOpenModalResetPassword: boolean = false;
    isOpenModalResetPasswordInfo: boolean = false;
    fullNameResetPassword: string = "";
    accountIdResetPassword: number = null
    newTimePassword: string = ""

    constructor(){
        makeAutoObservable(this);
    }

    changeNewReassignEmails = (residentKey: string = "", contactKey:string = "") => {
            this.selectedNewResidentKey = residentKey;
            this.selectedNewContactKey = contactKey;
            if(this.isReassignEmailError){this.isReassignEmailError=false}
    }

    clearNewReassignEmails = () => {
        runInAction(()=>{
            this.reassignEmail = "";
            this.newReassignEmails = [];
            this.selectedNewResidentKey = "";
            this.selectedNewContactKey = "";
            if(this.isReassignEmailError){this.isReassignEmailError=false}
        })
    }

    openModalReassignEmail = (email: string = "") => {
        runInAction(()=>{
            getUserLookupContactsByResident(email).then(res => {
                let resultData:Array<{ value: string; label: string }> = []
                Object.keys(res.data).map(item =>{
                    resultData.push({ value: item, label: res.data[item] })
                })
                if(resultData.length > 0){
                    this.newReassignEmails = resultData
                    this.isOpenModalReassignEmail = true
                    this.reassignEmail = email
                    if(this.isReassignEmailError){this.isReassignEmailError=false}
                }else{
                    this.newReassignEmails = []
                    this.isOpenModalReassignEmail = false
                    this.reassignEmail = ""
                    this.isReassignEmailError = true;
                }
            }).catch(()=> {
                this.newReassignEmails = []
                this.isOpenModalReassignEmail = false
                this.reassignEmail = ""
                if(this.isReassignEmailError){this.isReassignEmailError=false}
            })
        })
    }
    closeModalReassignEmail = () => {
        runInAction(()=>{
            this.isOpenModalReassignEmail = false
            this.reassignEmail = ""
            this.newReassignEmails = [];
            this.selectedNewResidentKey = "";
            this.selectedNewContactKey = "";
            if(this.isReassignEmailError){this.isReassignEmailError=false}
        })
    }

    openModalResetPassword = (fullName:string = "", id:number = null) => {
        runInAction(()=>{
            this.fullNameResetPassword = fullName
            this.accountIdResetPassword = id
            this.isOpenModalResetPassword = true
            if(this.isReassignEmailError){this.isReassignEmailError=false}
        })
        
    }
    closeModalResetPassword = () => {
        runInAction(()=>{
            this.fullNameResetPassword = ""
            this.accountIdResetPassword = null
            this.isOpenModalResetPassword = false
            if(this.isReassignEmailError){this.isReassignEmailError=false}
        })
    }

    openModalResetPasswordInfo = (timePassword: string = "") =>{
        runInAction(()=>{
            this.newTimePassword = timePassword
            this.isOpenModalResetPasswordInfo = true
            if(this.isReassignEmailError){this.isReassignEmailError=false}
        })
    }

    closeModalResetPasswordInfo = () =>{
        runInAction(()=>{
            this.newTimePassword = ""
            this.isOpenModalResetPasswordInfo = false
            if(this.isReassignEmailError){this.isReassignEmailError=false}
        })
    }

    getUserListToManageAction = (search: string = null, page: number = null) => {
        const requestId = this.activeRequestId + 1;
        this.activeRequestId = requestId;
        if(!this.isLoading){
            this.isLoading = true;
            if(this.isReassignEmailError){this.isReassignEmailError=false}
        }
        let request;

        if(search != null && page != null){
            request = getUserListToManageAsync(search,page)
        }else if (search != null && page == null){
            request = getUserListToManageAsync(search)
        }else if(search == null && page != null){
            request = getUserListToManageAsync("",page)
        }else{
            request = getUserListToManageAsync()
        }

        return request.then(res=> {
            runInAction(() => {
                if (this.activeRequestId !== requestId) {
                    return
                }
                this.data = res.data
                if(this.isReassignEmailError){this.isReassignEmailError=false}
                if(this.isLoading){
                    this.isLoading = false;
                }
            })
            return res
        }).catch(err => {
            runInAction(() => {
                if (this.activeRequestId !== requestId) {
                    return
                }
                this.error = err?.message ?? "Unable to load completed registrations."
                if(this.isReassignEmailError){this.isReassignEmailError=false}
                if(this.isLoading){
                    this.isLoading = false;
                }
            })
            return null
        })
    }
}
export default UserListToManage;
